/**
 * Helper for presential provider profile completeness.
 * User object is the one returned by GET /users/profile (data.data or data).
 * @param {Object} user - User from /users/profile
 * @returns {{ isPresential: boolean, needsLocation: boolean }}
 */
export function usePresentialProfile (user) {
  if (!user || typeof user !== 'object') {
    return { isPresential: false, needsLocation: false }
  }
  const isPresential =
    user.provider_type === 'presential' || user.provider_type === 'both'
  const hasLocation =
    user.latitude != null &&
    user.longitude != null &&
    String(user.latitude).trim() !== '' &&
    String(user.longitude).trim() !== ''
  const needsLocation = isPresential && !hasLocation
  return { isPresential, needsLocation }
}
